const options = {
  5: "bg-pink-400/5",
  10: "bg-pink-400/10",
  25: "bg-pink-400/25",
  50: "bg-pink-400/50",
  75: "bg-pink-400/75",
  90: "bg-pink-400/90",
  100: "bg-pink-400",
};

const from = {
  5: "from-pink-400/5",
  10: "from-pink-400/10",
  25: "from-pink-400/25",
  50: "from-pink-400/50",
  75: "from-pink-400/75",
  90: "from-pink-400/90",
  100: "from-pink-400",
};

export default function getBackgroundPink400(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
